import ComparePlansLink from 'pricing-pages-lib/components/ComparePlansLink';
import { ProPlusSupportContent } from 'pricing-pages-lib/upgrade-page/ProPlusSupportContent';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useSelector } from 'react-redux';
import { SALES_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import { PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { SALES } from 'self-service-api/constants/ProductLines';
import { getHighlightsForProductLine, getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { SCREENS } from '../../constants/tracking/Screens';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { highestProductLevelFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import ProductFeatureTable from '../feature-table/ProductFeatureTable';
import RecommendedSalesFooter from './RecommendedSalesFooter';
import RecommendedSalesHeaderBanner from './RecommendedSalesHeaderBanner';
import RecommendedSalesFeaturesPanel from './recommendedSalesFeaturesPanel/RecommendedSalesFeaturesPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendedSalesHubProContainer = () => {
  const productLine = SALES;
  const isAppReady = useGlobalLoading();
  const productLevelOwned = useSelector(state => {
    if (!isAppReady) return null;
    return highestProductLevelFromProductInventorySelector(state, {
      productLine
    });
  });
  const productLevels = [productLevelOwned || 'FREE', 'PROFESSIONAL'];
  const highlightedProducts = getHighlightsForProductLine(productLine);
  const filteredHighlightedProducts = highlightedProducts.filter(apiName => {
    const localProductLevel = getProductLevelFromApiNameString(apiName);
    return productLevels.includes(localProductLevel);
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RecommendedSalesHeaderBanner, {}), /*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(RecommendedSalesFeaturesPanel, {
        productLevel: PROFESSIONAL,
        productLine: productLine,
        featureStoreFeature: "accountOverview",
        apiName: SALES_HUB_PROFESSIONAL
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ProductFeatureTable, {
        productLine: productLine,
        shouldShowRecommended: true,
        highlightedProducts: filteredHighlightedProducts,
        screen: SCREENS.RECOMMENDED
      }, `${productLine}-recommended-feature-table`)
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ProPlusSupportContent, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(RecommendedSalesFooter, {})
    })]
  });
};
export default RecommendedSalesHubProContainer;